import React, { useEffect, useState } from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
// import '../../summary/footer/footer.scss';
import './footer.scss';
import {
  getFromSessionStorage,
  numberWithCommas,
  removeConfirmOrderStorage,
  scrollToTop,
  showServiceError,
  setInSessionStorage,
  findParamFromUrl,
  isAuthForDev,
  isDevEnv
} from 'common/utils/app.utils';
import { cartCheckout, cartSearch } from 'home/view/manage-feasibility/services/multiSite-service';
import { AUTHORIZATION_HEADER, LEAD_STATUS, MODULE_ID, PROCEED_CONFIRMATION } from 'home/common/constants/constants';
import { getProductType, isNLD_OR_LL, ROUTES, isBulkUpgrade, isPreOrder } from 'common/constants/app.constants';
import { AUTH_TOKEN, CART_ID, MULTI_SITE_MODULE_ID, CART_STATUS } from 'home/view/manage-feasibility/constants';
import FooterLoader from './footer-loader/footerLoader';
import CustomModal from 'dedicated/components/customModal/customModal';
import { PLAN_CONFIGURATION } from 'home/view/manage-feasibility/constants/multiSite-constants';
import {
  CUSTOMER_MESSAGE,
  isUserTypeIsKAM,
  MEDIA_TYPES_OTC,
  PROCEED_CONFIRMATION_ORDER_SUMMARY,
  TOAST_TYPE,
  existingARCGreaterThanNewARC
} from '../configure-plan-pricing-constant';
import { getKamDetailsNotification } from 'home/view/check-feasibility/comp-generator/component.generator';

export const Footer = ({
  blockJourney,
  reFetch,
  lineItems,
  showCancelPopUp,
  history,
  SetBlockJourney,
  setToast,
  setMessage,
  partyId,
  setCustomerDetail,
  tellParentIfSameMedia,
  customerDetail
}) => {
  const { totalElement, feasibilityMediaMap } = lineItems;
  const [viewMore, setViewMore] = useState(false);
  const [toggleConfirmationPopup, setToggleConfirmationPopup] = useState(false);
  const [planDetail, setPlanDetail] = useState({});
  const [isPNQCompleted, setIsPNQCompleted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  let timeId;
  const onViewMoreLessClick = () => {
    setViewMore(!viewMore);
  };

  const onSubmit = () => {
    if (isPreOrder()) {
      handleGotoOrderSummary();
    } else {
      setToggleConfirmationPopup(true);
    }
  };

  const onCancel = () => {
    showCancelPopUp(true);
  };

  const toggelToastPopup = () => {
    setToast(false, '', '');
  };

  const isPNQ_InProgressOrCompleted = (status, leadId, customerDetail) => {
    if (!isUserTypeIsKAM()) {
      if (status === LEAD_STATUS.SEND_TO_DOA) {
        SetBlockJourney(true);
        setMessage({
          text: CUSTOMER_MESSAGE.PRE_ORDER_DOA_INFO,
          type: TOAST_TYPE.WARNING
        });
        setToggleConfirmationPopup(false);
        timeId = setTimeout(() => {
          setToast(true, CUSTOMER_MESSAGE.SEND_TO_DOA, TOAST_TYPE.WARNING);
        }, 1000);
        return true;
      } else if (status === LEAD_STATUS.PNQ_IN_PROGRESS) {
        SetBlockJourney(true);
        setMessage({
          text: CUSTOMER_MESSAGE.NONE_STANDARD_UNDER_REVIEW,
          type: TOAST_TYPE.WARNING
        });
        setToggleConfirmationPopup(false);
        timeId = setTimeout(() => {
          setToast(true, getKamDetailsNotification(customerDetail?.kamDetails), TOAST_TYPE.WARNING);
        }, 1000);
        return true;
      } else if (status === LEAD_STATUS.PRICING_DOA_APPROVED) {
        SetBlockJourney(true);
        setIsPNQCompleted(true);
        setMessage({
          text: CUSTOMER_MESSAGE.PRICING_DOA_APPROVED,
          type: TOAST_TYPE.SUCCESS
        });
        timeId = setTimeout(() => {
          setToast(true, CUSTOMER_MESSAGE.PRICING_DOA_APPROVED, TOAST_TYPE.SUCCESS);
        }, 1000);
      } else if (status === LEAD_STATUS.PNQ_COMPLETED) {
        SetBlockJourney(true);
        setIsPNQCompleted(true);
        setMessage({
          text: CUSTOMER_MESSAGE.PRICE_UPDATED,
          type: TOAST_TYPE.ERROR
        });
        timeId = setTimeout(() => {
          setToast(true, CUSTOMER_MESSAGE.PRICE_UPDATED_TOAST, TOAST_TYPE.SUCCESS);
        }, 1000);
      } else if (status === LEAD_STATUS.PNQ_CANCELED) {
        SetBlockJourney(true);
        setIsPNQCompleted(false);
      } else if (status === LEAD_STATUS.PRICING_DOA_REJECTED) {
        toggelToastPopup();
        let redirectUrl = ROUTES.DEDICATED_CANCEL;
        if (partyId) {
          redirectUrl = redirectUrl + '?partyId=' + partyId;
        }
        history && history.push(redirectUrl, { userType: 'KAM', reason: '', orderId: leadId, doaStatus: 'REJECTED', product: getProductType() });
      }
      scrollToTop();
    }
    return false;
  };

  const isSameMedia = (sameMedia = '') => {
    if (sameMedia) {
      SetBlockJourney(true);
      setMessage({
        text: sameMedia,
        type: TOAST_TYPE.ERROR
      });
    } else {
      SetBlockJourney(false);
      setMessage({
        text: '',
        type: TOAST_TYPE.ERROR
      });
    }
  };

  const getPrice = () => {
    cartSearch(getFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER), true, { additionalFields: 'CUSTOMER_DETAIL' }).then(
      ({ res }) => {
        if (res) {
          const {
            data: { result }
          } = res;
          if (Array.isArray(result.cartDataList) && result.cartDataList.length > 0) {
            const savedCartId = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID);

            let cart = {};

            if (savedCartId) {
              cart = result.cartDataList.find(({ cartId }) => cartId === savedCartId);
            } else {
              cart = result.cartDataList.find(({ cartStatus }) =>
                [
                  PLAN_CONFIGURATION.PROGRESS,
                  PLAN_CONFIGURATION.SAVED,
                  PLAN_CONFIGURATION.PNQ_IN_PROGRESS,
                  PLAN_CONFIGURATION.SEND_TO_DOA,
                  PLAN_CONFIGURATION.PNQ_COMPLETED,
                  PLAN_CONFIGURATION.PRICING_DOA_APPROVED,
                  PLAN_CONFIGURATION.SUBMITTED,
                  PLAN_CONFIGURATION.PNQ_CANCELED,
                  PLAN_CONFIGURATION.PRICING_DOA_REJECTED
                ].includes(cartStatus)
              );
            }

            setInSessionStorage(MULTI_SITE_MODULE_ID, CART_STATUS, cart.cartStatus);

            if (cart && (cart.cartStatus === PLAN_CONFIGURATION.PROGRESS || cart.cartStatus === PLAN_CONFIGURATION.SAVED)) {
              const sameMedia = cart?.message;
              isSameMedia(sameMedia);
              tellParentIfSameMedia(sameMedia);
            }
            if (cart && cart.cartStatus !== PLAN_CONFIGURATION.SUBMITTED) {
              setPlanDetail(cart.planDetail && cart.planDetail);
              setCustomerDetail({ ...(cart.customer || {}), finalPrice: cart?.planDetail?.price?.finalPrice });
              isPNQ_InProgressOrCompleted(cart.cartStatus, result.leadId, cart.customer);
            } else {
              removeConfirmOrderStorage();
              const queryParam = partyId ? `?partyId=${partyId}` : '';
              history.push(ROUTES.DEDICATED_ORDER_SUMMARY + queryParam);
            }
          }
        }
        scrollToTop();
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const handleGotoOrderSummary = async () => {
    try {
      const leadAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, AUTH_TOKEN);

      const reqObj = {
        cartId: getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_ID),
        status: PLAN_CONFIGURATION.SUBMITTED
      };
      setIsLoading(true);
      const { res, err } = await cartCheckout(leadAuthToken, reqObj);
      if (res) {
        const { data: { success = false, result: cart = {} } = {} } = res;
        if (success && isBulkUpgrade()) {
          setInSessionStorage(MULTI_SITE_MODULE_ID, CART_STATUS, cart?.cartStatus);
        }
        if (success && !isPNQ_InProgressOrCompleted(cart.cartStatus, '', customerDetail)) {
          removeConfirmOrderStorage();
          let queryParam = partyId ? `?partyId=${partyId}` : '';

          if (isDevEnv() && isAuthForDev()) {
            queryParam = queryParam + '&isAuth=' + findParamFromUrl('isAuth', false);
          }

          history.push(ROUTES.DEDICATED_ORDER_SUMMARY + queryParam);
        }
      } else if (err) {
        console.log(err);
        throw new Error(err);
      }
      setIsLoading(false);
      scrollToTop();
    } catch (error) {
      showServiceError({ show: true, data: '', redirect: false });
      setIsLoading(false);
    }
  };

  const customPopupSubmit = () => {
    handleGotoOrderSummary();
  };

  const isExistingARCGreaterThanNewARC = (lineItems) => {
    let isPriceGreater = false;
    const currentContent = lineItems?.content;

    if (currentContent?.length > 0) {
      for (let i = 0; i < currentContent.length; i++) {
        if (existingARCGreaterThanNewARC(currentContent[i]?.rawContent)) {
          isPriceGreater = true;
          break;
        }
      }
    }

    return isPriceGreater;
  };

  const isOffnetOrThirdPartyMedia = (feasibilityMediaMap) => {
    const isOffnet = (feasibilityMediaMap && feasibilityMediaMap['OFFNET']) || 0;
    const isThirdParty = (feasibilityMediaMap && feasibilityMediaMap['THIRD_PARTY']) || 0;
    const isOffnetOrThirdParty = isOffnet > 0 || isThirdParty > 0;

    return isOffnetOrThirdParty;
  };

  const isPNQEligible = (planDetail, feasibilityMediaMap) => {
    const savedCartStatus = getFromSessionStorage(MULTI_SITE_MODULE_ID, CART_STATUS);
    const isPnQInProgress = savedCartStatus === PLAN_CONFIGURATION.PROGRESS || savedCartStatus === PLAN_CONFIGURATION.SAVED;
    const isFinalPrice = planDetail && planDetail.price && planDetail.price.finalPrice;
    const isMediaOTC = !!(isPnQInProgress && feasibilityMediaMap && ((feasibilityMediaMap['OFFNET'] || 0) + feasibilityMediaMap['THIRD_PARTY'] || 0));

    if (isBulkUpgrade() && isPnQInProgress) {
      if (isExistingARCGreaterThanNewARC(lineItems) || isOffnetOrThirdPartyMedia(feasibilityMediaMap)) {
        return false;
      }
    }

    return isFinalPrice && !isMediaOTC ? true : false;
  };

  const getTotalAmount = () => {
    if (isBulkUpgrade() && isExistingARCGreaterThanNewARC(lineItems)) {
      return 0;
    }

    return planDetail ? numberWithCommas(planDetail.price.finalPrice ? planDetail.totalPrice : 0) : '-';
  };

  const getPriceValue = () => {};

  useEffect(() => {
    setPlanDetail({});
    getPrice();
    return () => {
      clearTimeout(timeId);
    };
  }, [reFetch]);

  useEffect(() => {
    document.getElementById('root').className = 'pricing-strip';
    return () => {
      document.getElementById('root').classList.remove('pricing-strip');
    };
  }, []);

  return (
    <div className={`selected-plans active ${toggleConfirmationPopup ? 'open' : ''}`}>
      {planDetail && Object.keys(planDetail).length > 0 ? (
        <React.Fragment>
          <div className={`inside-plan ${viewMore ? 'show_full_view' : ''}`}>
            <div className="plan-info">
              <div className="plan_details_veiw">
                <div className="left_col">
                  <h4>Total Amount</h4>
                  <div class="value mt-10">&#8377; {getTotalAmount()}</div>
                </div>
                <div className="right_col">
                  <div className="view_type" onClick={onViewMoreLessClick}>
                    {viewMore ? 'View Less' : 'View More'} <span className={`animatedarrow ${viewMore ? 'arrow_up' : ''} `}></span>
                  </div>
                </div>
              </div>
              <div className="condition_info">Excluding Taxes.</div>
            </div>
            <div className="plan-details">
              <div className="item_list">
                <div className="items tital_for_mobile">
                  <div className="label">{isNLD_OR_LL() ? 'NUMBER OF LINKS IN CART' : 'Total Sites in Cart'}</div>
                  <div className="value">
                    <strong>{isNLD_OR_LL() ? Math.floor(totalElement / 2) : totalElement} </strong>
                  </div>
                </div>
                <div className="items border-bottom">
                  <div className="label">{isNLD_OR_LL() ? 'NUMBER OF LINKS IN CART' : 'Total Sites in Cart'}</div>
                  <div className="value">
                    <strong>{isNLD_OR_LL() ? Math.floor(totalElement / 2) : totalElement} </strong>
                  </div>
                </div>
              </div>
              <div className="action">
                <Button variant="outlinebtn" onClick={onCancel} disabled={(blockJourney && !isPNQCompleted) || totalElement === 0}>
                  Cancel
                </Button>
                <Button className="activebtn" onClick={onSubmit} disabled={(blockJourney && !isPNQCompleted) || totalElement === 0 || isLoading}>
                  Proceed
                  {isLoading && <span className="loading_icon"></span>}
                </Button>
              </div>
            </div>
          </div>
          {toggleConfirmationPopup && (
            <CustomModal
              customPopupTitle={
                isPNQEligible(planDetail, feasibilityMediaMap) ? PROCEED_CONFIRMATION_ORDER_SUMMARY.CONFIRMATION_TITLE : PROCEED_CONFIRMATION_ORDER_SUMMARY.NOTICE_TITLE
              }
              customPopupMsg={isPNQEligible(planDetail, feasibilityMediaMap) ? PROCEED_CONFIRMATION_ORDER_SUMMARY.CONFIRMATION_MSG : PROCEED_CONFIRMATION_ORDER_SUMMARY.NOTICE_MSG}
              submitCustomPopup={customPopupSubmit}
              closeCustomPopup={setToggleConfirmationPopup}
              isLoading={isLoading}
            />
          )}
        </React.Fragment>
      ) : (
        <FooterLoader />
      )}
    </div>
  );
};
